import { addDays, addMinutes, format, startOfMonth } from '@e3dc-react/shell/Libs/date'
import { ChargingSessionDto } from '../../charging-sessions/api/dto/charging-sessions.dto'
import { MOCK_CURRENCY } from './mock-properties'

const MOCK_START_DATE = startOfMonth(new Date())
const DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss"

export const MOCK_CHARGING_SESSIONS: ChargingSessionDto[] = [
  {
    session: {
      kwh: 11.61,
      status: 'COMPLETED',
      country_code: 'DE',
      party_id: 'HGE',
      id: 'd895b6ae-ba93-4480-ba88-ca2bfc63e6f9',
      start_date_time: format(addMinutes(addDays(MOCK_START_DATE, 1), 22), DATE_FORMAT),
      end_date_time: format(addMinutes(addDays(MOCK_START_DATE, 1), 30), DATE_FORMAT),
      cdr_token: {
        uid: '59838029-dd88-4ec0-83ac-7ab37f6e7b28',
        country_code: 'DE',
        party_id: 'HGE',
        type: 'RFID',
        contract_id: 'hagerBridgeContract',
      },
      auth_method: 'WHITELIST',
      authorization_reference: null,
      location_id: 'a3b3f606-7409-4ef1-8096-13fad3f2dd20',
      evse_uid: 'd982cb4b-4ce6-4cd7-9bf6-6525e0f5ae00',
      connector_id: '1',
      meter_id: null,
      currency: MOCK_CURRENCY,
      charging_periods: null,
      total_cost: {
        excl_vat: 0,
        incl_vat: 0,
      },
      lastUpdated: format(addMinutes(addDays(MOCK_START_DATE, 1), 32), DATE_FORMAT),
    },
    wallboxId: '00141648D960F201',
    wallboxName: null,
    wallboxType: 5,
    emobilityToken: '4a927e2f',
    tokenName: 'Demo car Updated',
    authType: 'RFID',
    energySolar: 3.56,
    energyDischarged: 3.4,
    dischargeTimeActive: 0,
    dischargeCounterReadingStart: 0,
    dischargeCounterReadingStop: 0,
    totalDischargeCost: null,
    chargeTimeActive: 22003,
    chargeTimeInactive: 107993,
    solarEnergyRatio: 0.96,
    duration: 129996,
    tariffCategory: null,
    cdrId: '6f7e8210-0b63-4d6f-9453-13ebb0e6314e',
    status: 'FINISHED',
    midEnergy: false,
    midEnergyInconsistent: false,
    midSessionOffline: false,
    chargePrice: 0,
    dischargePrice: 0,
    solarPrice: 0,
    gridPrice: 0,
    gridCost: 0,
    solarCost: 0,
    emobilitySessionId: '6f7e8210-0b63',
  },
  {
    session: {
      kwh: 11.34,
      status: 'COMPLETED',
      country_code: 'DE',
      party_id: 'HGE',
      id: '42e88ae8-d614-454e-9062-87bbd4d6bc58',
      start_date_time: format(addMinutes(addDays(MOCK_START_DATE, 6), 47), DATE_FORMAT),
      end_date_time: format(addMinutes(addDays(MOCK_START_DATE, 6), 53), DATE_FORMAT),
      cdr_token: {
        uid: '59838029-dd88-4ec0-83ac-7ab37f6e7b28',
        country_code: 'DE',
        party_id: 'HGE',
        type: 'RFID',
        contract_id: 'hagerBridgeContract',
      },
      auth_method: 'WHITELIST',
      authorization_reference: null,
      location_id: 'a3b3f606-7409-4ef1-8096-13fad3f2dd20',
      evse_uid: 'd7503048-1090-40f1-aa87-8c127f1258bb',
      connector_id: '1',
      meter_id: null,
      currency: MOCK_CURRENCY,
      charging_periods: null,
      total_cost: {
        excl_vat: 0,
        incl_vat: 0,
      },
      lastUpdated: format(addMinutes(addDays(MOCK_START_DATE, 6), 54), DATE_FORMAT),
    },
    wallboxId: '00141648D963A401',
    wallboxName: null,
    wallboxType: 5,
    emobilityToken: '4a927e2f',
    tokenName: 'Demo car Updated',
    authType: 'RFID',
    energySolar: 3.12,
    energyDischarged: 2.22,
    dischargeTimeActive: 0,
    dischargeCounterReadingStart: 0,
    dischargeCounterReadingStop: 0,
    totalDischargeCost: null,
    chargeTimeActive: 0,
    chargeTimeInactive: 10003,
    solarEnergyRatio: 0,
    duration: 10003,
    tariffCategory: null,
    cdrId: '5d443618-beec-4865-9d52-7c79e02514da',
    status: 'FINISHED_NO_ACTION',
    midEnergy: false,
    midEnergyInconsistent: false,
    midSessionOffline: false,
    chargePrice: 0,
    dischargePrice: 0,
    solarPrice: 0,
    gridPrice: 0,
    gridCost: 0,
    solarCost: 0,
    emobilitySessionId: '6f7e8210-0b63',
  },
]
